export default "__VITE_ASSET__94b271ab__"